module.exports = __webpack_public_path__ + "static/onpony-mobile-629ff600eb83b449e9341f62019e35cc.png";